// extracted by mini-css-extract-plugin
module.exports = {"innerContent":"HomePageHeroImg_innerContent__XJaq6","rightSide":"HomePageHeroImg_rightSide__xuIcj"};